import PageHeaderTenant from './PageHeaderTenant.styled';

export default PageHeaderTenant;
